import React from 'react';
import './Impressum.css';

const Legal = () => {
  return (
    <div className="container my-5" style={{ maxWidth: 800 }}>
      <h1 className="mb-4">General Terms and Conditions (GTC)</h1>
      <p><em>Last updated: February 2026</em></p>

      <h2 className="mt-4">1. Scope</h2>
      <p>
        These General Terms and Conditions (hereinafter "GTC") apply to all orders placed via the online shop
        at <a href="https://vegbox.ch" target="_blank" rel="noreferrer">www.vegbox.ch</a> operated by
        Vegbox GmbH (hereinafter "Vegbox"). By placing an order, the customer accepts these GTC.
      </p>
      <p>
        The offer is directed exclusively at customers with a residential or business address in Switzerland.
        Deliveries are made only to addresses in Switzerland.
      </p>

      <h2 className="mt-4">2. Offer and Pricing</h2>
      <p>
        All prices in the online shop are stated in Swiss Francs (CHF) and include the applicable
        value-added tax (MwSt. 8.1%). Shipping costs are displayed separately during checkout.
        Shipping is free for orders of CHF 80 or more.
      </p>
      <p>
        Vegbox reserves the right to change prices at any time. The price valid at the time of the order applies.
        Obvious pricing errors do not constitute a binding offer.
      </p>

      <h2 className="mt-4">3. Conclusion of Contract</h2>
      <p>
        The products and prices displayed in the online shop constitute a non-binding offer.
        The contract is concluded when the customer places an order and receives an order confirmation by email.
      </p>

      <h2 className="mt-4">4. Payment</h2>
      <p>
        Payment is made via the payment methods offered in the online shop (credit card via Stripe).
        The amount is charged at the time of the order.
      </p>

      <h2 className="mt-4">5. Delivery</h2>
      <p>
        Vegbox delivers to addresses in Switzerland. The delivery date and time slot are selected
        by the customer during checkout. Vegbox endeavors to meet the selected delivery time but
        cannot guarantee exact delivery times.
      </p>
      <p>
        If the customer is not available at the agreed delivery time, Vegbox may charge for
        additional delivery costs.
      </p>

      <h2 className="mt-4">6. Right of Withdrawal / Returns</h2>
      <p>
        As the products sold are perishable food items, returns and exchanges are excluded
        in accordance with Swiss law. Once an order has been confirmed, there is no right of withdrawal.
      </p>
      <p>
        In the event of defective or incorrect deliveries, the customer must notify Vegbox
        within 24 hours of receipt. Vegbox will arrange for a replacement or refund.
      </p>

      <h2 className="mt-4">7. Warranty</h2>
      <p>
        Vegbox guarantees the freshness and quality of the products at the time of delivery.
        Due to the nature of perishable goods, warranty claims are limited to the time of delivery.
        The customer is obligated to inspect goods upon receipt and report any defects immediately.
      </p>

      <h2 className="mt-4">8. Liability</h2>
      <p>
        Vegbox is liable only for damages caused by intent or gross negligence.
        Liability for slight negligence, indirect or consequential damages, and lost profits is excluded.
      </p>

      <h2 className="mt-4">9. Data Protection</h2>
      <p>
        The handling of personal data is governed by our{' '}
        <a href="/privacy-policy">Privacy Policy</a>.
      </p>

      <h2 className="mt-4">10. Applicable Law and Jurisdiction</h2>
      <p>
        Swiss law applies. The exclusive place of jurisdiction is Dübendorf, Switzerland,
        subject to mandatory statutory provisions.
      </p>

      <h2 className="mt-4">11. Severability Clause</h2>
      <p>
        Should any provision of these GTC be or become invalid, the validity of the remaining
        provisions shall not be affected.
      </p>

      <h2 className="mt-4">12. Contact</h2>
      <p>
        <strong>Vegbox GmbH</strong><br />
        Dietlikonstrasse 29, 8600 Dübendorf<br />
        Phone: +41 78 222 42 36<br />
        Email: <a href="mailto:vegboxgmbh@gmail.com">vegboxgmbh@gmail.com</a><br />
        Website: <a href="https://vegbox.ch" target="_blank" rel="noreferrer">www.vegbox.ch</a>
      </p>

      <p className="mt-4"><em>© 2026 Vegbox GmbH — All rights reserved</em></p>
    </div>
  );
};

export default Legal;
